"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _ThemeProvider = require("./ThemeProvider");
const useSetTheme = () => {
  // Replace current theme with provided object
  const setTheme = (0, _react.useContext)(_ThemeProvider.ThemeSetterContext);
  // Fail fast if dev uses useSetTheme outside of ThemeProvider
  if (setTheme instanceof Error) {
    throw setTheme;
  }

  // Merge provided object into current theme
  const editTheme = (0, _react.useCallback)(newTheme => setTheme(function () {
    let oldTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      ...oldTheme,
      ...newTheme
    };
  }), [setTheme]);
  return {
    setTheme,
    editTheme
  };
};
var _default = exports.default = useSetTheme;